import { FC } from 'react';
import { Box, Divider, Typography, useTheme } from '@mui/material';

interface MenuHeaderProps {
    title: string;
    subtitle?: string;
}

export const MenuHeader: FC<MenuHeaderProps> = ({ title, subtitle }) => {
    const theme = useTheme();

    return (
        <>
            <Box
                sx={{
                    p: 2,
                    pt: 10, // Account for fixed header
                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                    color: 'white',
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {title}
                </Typography>
                {subtitle && (
                    <Typography variant="caption" sx={{ opacity: 0.8 }}>
                        {subtitle}
                    </Typography>
                )}
            </Box>
            <Divider />
        </>
    );
};

